<style>
html {
  font-size: 16px;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
  background-color: #f5f8ff;
  overflow: auto;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}
</style>

<template>
  <div class="flex-col page">
    <keep-alive>
      <div class="container">
        <div class="haderView flex-row items-center">
          <img class="logo" :src="productLogo" alt="" />
          <div class="content-title flex-row items-center">
            {{ this.productName }}
          </div>
          <div class="content-subtitle flex-row items-center">
            {{ this.feature }}
          </div>
        </div>

        <div class="content flex-col items-center">
          <div class="amount flex-col justify-center items-center">
            <span class="amount_title">您预估可借(元)</span>
            <div class="amount_img">
              <span class="amount_lab">23,800</span>
            </div>
            <span class="amount_rate">最终结果已审批为准</span>
          </div>
          <button
            class="flex-col justify-center items-center func-button"
            @click="handleSubmit"
          >
            <span class="font_2 text_18">{{ btnTxt }}</span>
          </button>
          <div class="download-button" @click="handleDownload">
            下载APP匹配更多资金
          </div>
        </div>
        <div class="flex-col auditIntro">
          <div class="auditIntro-arrow">
            <div class="auditIntro-title">产品介绍</div>
          </div>
          <div class="flex-row auditIntro-item">
            <span class="auditIntro-item-title">借款额度</span>
            <span class="auditIntro-item-lab">最高可借20万</span>
          </div>
          <div class="flex-row auditIntro-item">
            <span class="auditIntro-item-title">利率</span>
            <span class="auditIntro-item-lab"
              >年化利率(单利){{ this.minLoanRate }}-{{
                this.maxLoanRate
              }}%</span
            >
          </div>
          <div class="flex-row auditIntro-item">
            <span class="auditIntro-item-title">放款方式</span>
            <span class="auditIntro-item-lab">放款到银行卡</span>
          </div>
          <div class="flex-row auditIntro-item">
            <span class="auditIntro-item-title">放款规则</span>
            <span class="auditIntro-item-lab">最长36期，随借随还</span>
          </div>
        </div>
      </div>
    </keep-alive>
    <!--    cpa弹窗-->
    <van-popup
      v-model="isShowPop"
      position="center"
      round
      v-if="this.popData.productName"
    >
      <div class="pop-countent">
        <div class="title-bg">
          <span class="title-text">点击去提现，立即拿钱</span>
          <span class="span-icon"></span>
        </div>
        <div class="countent">
          <img :src="this.popData.logo" class="product-logo" />
          <div class="product-infoBg flex-col justify-center">
            <div class="product-info">
              <div class="product-name">{{ popData.productName }}</div>
              <div class="product-num">{{ popData.loanAmount }}元</div>
            </div>
            <div class="product-tip flex-row items-center">
              <div class="product-tipImg"></div>
              <div class="product-tipTitle">秒申请，秒审核！两小时内放款</div>
            </div>
          </div>
        </div>
        <div class="agree-txt">
          <van-checkbox
            v-model="checked"
            class="check-box"
            shape="square"
          ></van-checkbox>
          <span class="txt"
            >我已阅读并同意<i @click="handleProtocol(9)"
              >《个人信息查询授权书》</i
            ></span
          >
        </div>
        <div class="btn-bg flex-row items-center justify-center">
          <div
            class="btn-cancel flex-row items-center justify-center"
            @click="handleCancelBtn"
          >
            确认离开
          </div>
          <div
            class="btn-confirm flex-row items-center justify-center"
            v-prevent-reclick
            @click="handlePopBtn"
          >
            去提现
          </div>
        </div>
      </div>
    </van-popup>
    <!--    协议弹窗-->
    <div class="po_section_1 flex-col po_bg" v-show="isShowProtocol">
      <div class="po_block_1 flex-col">
        <div class="po_box_1 flex-col">
          <img
            class="po_thumbnail_1"
            referrerpolicy="no-referrer"
            src="../../assets/images/model8/model8_po_close.png"
            v-on:click="handelCloseProtocol"
          />
          <div class="po_text-group_1 flex-col justify-between">
            <span class="po_text_1">请阅读以下协议</span>
          </div>
          <div class="flex-col po_content justify-between">
            <span class="contentText" v-html="apiProduct.content"> </span>
          </div>
          <button
            class="po_button_1 flex-col"
            @click="handelAgreeProtocol"
            v-prevent-reclick
          >
            <span class="po_text_2">我已阅读并同意授权</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="././public/js/base.js">
import protocol from "./protocol.vue";
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    protocol() {
      return protocol
    }
  }
})
</script>
<script src="./src/css/modelBase.css"></script>
<script src="./src/utils/preventReClick.js"></script>
<script>
import * as API_Common from "@/api/common";
import Vue from "vue";
import Decimal from "decimal.js";
import {
  addDownloadRecord,
  toRedirectUrlAndSaveRecordNoDebounce,
} from "@/api/common";
export default {
  components: {},
  data() {
    return {
      channel: this.$route.query.source,
      model: sessionStorage.getItem("model"),
      isShowPop:
        !window.localStorage.getItem("closePop") &&
        window.localStorage.getItem("backFlag"),
      default_cattle:
        'this.src="' + require("../../../public/fangxin_logo.png") + '"', //加载图片报错时处理方法
      amount_repayment: "", //1000借款1天还款金额
      minLoanRate: "",
      maxLoanRate: "",
      rate: 0,
      checked: false,
      feature: "",
      isShowProtocol: false,
      isClickProtocol: false,
      downAppUrl: "",
      showPop: false, //cpa弹窗
      productName: "",
      productLogo: "",
      popData: {
        isShieldCity: false,
        linkUrl: undefined,
      },
      unionLogin: {
        productId: 0,
        url: "",
      },
      recommendProduct: {},
      productList: [],
      btnTxt: "立即下载",
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        redirectUrl: "",
        grantValue: "",
      },
    };
  },
  mounted() {
    this.getIsShieldCity();
    window.history.pushState(null, document.title, window.location.href);
    this.preventBackButton();
    // 兼容苹果跳转回退不刷新页面（不触发mounted）
    var browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
    }
  },
  created() {
    this.handleUserResidenceTime();
    this.getAPIProduct();
    this.scrollToTop();
    if (
      !window.localStorage.getItem("closePop") &&
      window.localStorage.getItem("backFlag") &&
      this.popData.productId
    ) {
      this.isShowPop = true;
    }
  },
  methods: {
    preventBackButton() {
      window.addEventListener("popstate", () => {
        // 重新添加记录，使浏览器历史记录中当前页面的实例增加
        window.history.pushState(null, document.title, window.location.href);
        // 在这里可以添加用户尝试返回时想要执行的操作，比如弹窗提示
        this.isShowPop = true;
      });
    },
    getIsShieldCity() {
      API_Common.getIsShieldCity(this.channel)
        .then((res) => {
          // 检查返回的响应是否有效
          if (res && res.code === 200) {
            // 如果当前城市未被屏蔽
            if (res.data === false) {
              this.getChannleProductList();
              this.getPopProduct();
            } else {
              this.defaultDisplayData();
            }
          } else {
            // 如果响应不正常，或者城市被屏蔽，显示默认数据
            this.defaultDisplayData();
          }
        })
        .catch((error) => {
          // 处理请求失败的情况
          console.error("获取城市屏蔽状态失败:", error);
          this.defaultDisplayData(); // 请求失败时展示默认数据
        });
    },
    // 根据渠道code读取产品推荐信息 将权重最大的进行显示
    getChannleProductList() {
      API_Common.getProductsInResultPage(this.channel).then((res) => {
        if (res !== undefined) {
          if (res.code === 200) {
            let dataArr = res.data;
            if (dataArr.length > 0) {
              this.recommendProduct = dataArr[0];
              this.btnTxt = "立即提现";
              this.productName = this.recommendProduct.name;
              this.productLogo = this.recommendProduct.imgUrl;
              this.productList = dataArr;
              this.minLoanRate = Decimal.mul(
                this.recommendProduct.minLoanRate,
                100
              );
              this.maxLoanRate = Decimal.mul(
                this.recommendProduct.maxLoanRate,
                100
              );
              if (this.recommendProduct.prodFeature) {
                this.feature = this.recommendProduct.prodFeature;
              } else {
                this.feature = "专业一站式借款平台";
              }
              if (this.recommendProduct.isToRegister === 1) {
                //获得联登的协议
                API_Common.getContent({
                  pageType: this.model === "modeldlb" ? 36 : 40,
                }).then((res) => {
                  this.apiProduct.content = res.data.content;
                });
              }
            } else {
              this.defaultDisplayData();
            }
          } else {
            this.defaultDisplayData();
          }
        } else {
          this.defaultDisplayData();
        }
      });
    },
    // 根据渠道code和进行到哪一步查询配置H5弹窗产品权重最大的值
    getPopProduct() {
      API_Common.getPopItem(this.channel).then((res) => {
        if (res.code === 200) {
          this.popData = res.data;
        } else {
          this.productName = "放鑫钱包";
        }
      });
    },
    //API机构和授权书
    getAPIProduct() {
      var that = this;
      API_Common.getUser2WhereApi().then((res) => {
        if (res) {
          if (res.code === 200) {
            that.apiProduct = res.data;
          } else {
            this.$toast(res);
          }
        }
      });
    },

    defaultDisplayData() {
      this.btnTxt = "立即下载";
      this.productName = "放鑫钱包";
      this.minLoanRate = 7.2;
      this.maxLoanRate = 24;
      this.recommendProduct.number = 100000;
      this.productLogo = require("../../../public/fangxin_logo.png");
      this.feature = "专业一站式借款平台";
    },
    //同意协议
    handelAgreeProtocol() {
      window.localStorage.setItem("isClickProtocol", "ture");
      window.localStorage.setItem("backFlag", "true");
      window.localStorage.removeItem("closePop");
      this.isShowProtocol = false;
      const buriedData = {
        productId: this.recommendProduct.id,
        showPage: 5,
      };
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            that.unionLogin = res.data;
          })
          .catch((error) => {})
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                productId: this.recommendProduct.id,
                showPage: 5,
              },
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },
    // 关闭协议弹窗
    handelCloseProtocol() {
      this.isShowProtocol = false;
    },

    //点击弹窗产品去申请
    handlePopBtn() {
      if (!this.checked) {
        this.$toast("请勾选同意个人信息查询授权书");
        return;
      }
      window.localStorage.setItem("closePop", "ture");
      window.localStorage.removeItem("backFlag");
      const url = this.popData.linkUrl;
      const buriedData = {
        productId: this.popData.productId,
        showPage: 7,
      };
      // toRedirectUrlAndSaveRecordNoDebounce(url, buriedData);
      let redirectUrl = this.popData.linkUrl; //默认跳转url
      let isWeCom = this.popData.isWeCom;
      if (this.popData.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.popData.productId,
          this.popData.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.popData.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          that.popData?.productId,
          that.popData?.hitRecordId
        )
          .then(async (res) => {
            that.unionLogin = res.data;
          })
          .catch((error) => {})
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                productId: that.popData.productId,
                showPage: 7,
              },
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },
    //cpa取消弹窗
    handleCancelBtn() {
      this.isShowPop = false;
      window.localStorage.setItem("closePop", "ture");
      window.localStorage.removeItem("backFlag");
    },
    //点击底部按钮
    handleSubmit() {
      if (this.popData.isShieldCity || !this.recommendProduct.id) {
        this.handleDownload();
      } else {
        this.isShowProtocol = true;
      }
    },
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url;
        }
      });
    },
    handleProtocol(pageType) {
      if (pageType === 12) {
        let userId = window.localStorage.getItem("userId");
        window.location.href =
          "/protocol.html?pageType=" + pageType + "&userId=" + userId;
      } else {
        window.location.href = "/protocol.html?pageType=" + pageType;
      }
    },
    handleDownload() {
      addDownloadRecord(this.channel);
      if (this.model === "model14") {
        API_Common.getDownloadUrlWithHaier(this.channel, 1).then((res) => {
          if (res.code === 200) {
            this.downAppUrl = res.data.url;
            this.$bridge.callhandler(
              "openExternalBrowser",
              { jumpUrl: this.downAppUrl },
              (data) => {
                // 处理返回数据
                console.log(data);
              }
            );
          }
        });
      } else if (this.model === "model15") {
        API_Common.getDownloadUrlWithHaier(this.channel, 2).then((res) => {
          if (res.code === 200) {
            this.downAppUrl = res.data.url;
            this.$bridge.callhandler(
              "openExternalBrowser",
              { jumpUrl: this.downAppUrl },
              (data) => {
                // 处理返回数据
                console.log(data);
              }
            );
          }
        });
      } else {
        API_Common.getDownloadUrl(this.channel).then((res) => {
          if (res.code === 200) {
            this.downAppUrl = res.data.url;
          }
          window.location.href = this.downAppUrl;
        });
      }
    },
    handleUserResidenceTime() {
      API_Common.delayModel8SUpdate(this.channel, 0, 0, 5);
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // 平滑滚动
        });
      }, 200);
    },
  },
};
</script>

<style scoped>
@import "../../css/userAudit1.css";
@import "../../css/cpaPopView.scss";
@import "../../css/protocolPopView.css";
@import "../../css/xybPopView.css";
</style>
